/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-shadow */

import React, { useState, useMemo } from 'react'
import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import {
  Grid,
  Radio,
  Divider,
  TextField,
  FormLabel,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Input,
  InputLabel,
  Box,
} from '@material-ui/core'
import MultiSelect from '@auteco/components/SpareParts/AutoCompleteFilter/MultiSelect'
import sparePartsService from '@auteco/services/sparePartsService'
import { useStyles, BootstrapInput } from './styles'
import DialogMaterials from '../DialogMaterials/DialogMaterials'

const initialForm = {
  marca: [],
  estado: [],
  vertical: [],
  categoria: [],
  clasificacion: [],
  subcategoria: [],
  acreedor: [],
  grupo_compras: [],
  indicador_abc: [],
  fechas: [
    new Date().toISOString().slice(0, 10),
    new Date().toISOString().slice(0, 10),
  ],
  type: '1',
  material: [],
  modelos: [],
  segmento: [],
  sub_segmento: [],
  familia: []
}

const initialChangeTrue = {
  vertical: true,
  clasificacion: true,
  categoria: true,
  subcategoria: true,
  segmento: true,
  sub_segmento: true,
  marca: true,
  familia: true,
  acreedor: true,
  grupo_compras: true,
  indicador_abc: true,
  estado: true,
}

const initialChangeFalse = {
  vertical: false,
  clasificacion: false,
  categoria: false,
  subcategoria: false,
  segmento: false,
  sub_segmento: false,
  marca: false,
  familia: false,
  acreedor: false,
  grupo_compras: false,
  indicador_abc: false,
  estado: false,
}

const uniqueBy = (arr, prop) =>
  arr
    .map((menu) => menu[prop])
    .filter((prop, index, arr) => arr.indexOf(prop) === index)

function formatFilters({ filters }) {
  return {
    vertical: uniqueBy(filters, 'vertical').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    clasificacion: uniqueBy(filters, 'clasificacion').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    categoria: uniqueBy(filters, 'categoria').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    subcategoria: uniqueBy(filters, 'subcategoria').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    segmento: uniqueBy(filters, 'segmento').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    sub_segmento: uniqueBy(filters, 'sub_segmento').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    marca: uniqueBy(filters, 'marca').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    familia: uniqueBy(filters, 'familia').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),

    acreedor: uniqueBy(filters, 'acreedor').map((name) =>
      name !== ' ' ? name : '---VACIO---',
    ),
    grupo_compras: uniqueBy(filters, 'grupo_compras').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    indicador_abc: uniqueBy(filters, 'indicador_abc').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    estado: uniqueBy(filters, 'estado').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
  }
}
function filtrarArray(array, filtro) {
  return array.filter(
    (obj) =>
      (filtro.estado.includes(obj.estado) || filtro.estado.length === 0) &&
      (filtro.clasificacion.includes(obj.clasificacion) ||
        filtro.clasificacion.length === 0) &&
      (filtro.categoria.includes(obj.categoria) ||
        filtro.categoria.length === 0) &&
      (filtro.subcategoria.includes(obj.subcategoria) ||
        filtro.subcategoria.length === 0) &&
      (filtro.segmento.includes(obj.segmento) || filtro.segmento.length === 0) &&
      (filtro.sub_segmento.includes(obj.sub_segmento) || filtro.sub_segmento.length === 0) &&
      (filtro.marca.includes(obj.marca) || filtro.marca.length === 0) &&
      (filtro.familia.includes(obj.familia) || filtro.familia.length === 0) &&
      (filtro.acreedor.includes(obj.acreedor) ||
        filtro.acreedor.length === 0) &&
      (filtro.grupo_compras.includes(obj.grupo_compras) ||
        filtro.grupo_compras.length === 0) &&
      (filtro.indicador_abc.includes(obj.indicador_abc) ||
        filtro.indicador_abc.length === 0) &&
      (filtro.vertical.includes(obj.vertical) || filtro.vertical.length === 0),
  )
}

const SPform = ({ filters, onSubmitForm }) => {
  const [form, setForm] = useState(initialForm)
  const [change, setChange] = useState(initialChangeFalse)
  const [materialsInfo, setMaterialsInfo] = useState([])
  const [openDialogMaterial, setOpenDialogMaterial] = useState(false)
  const copyNewArray = [...filters]
  const disabledBtnMaterial =
    form.material.length > 0
      ? !form.material.every((material) => material.length === 8)
      : true

  const classes = useStyles()

  const handleDialogMaterial = async (value, get) => {
    if (get) {
      const { data } = await sparePartsService.getMaterialsInfo(form.material)
      if (data) {
        setMaterialsInfo(data)
      }
    }
    setOpenDialogMaterial(value)
  }

  const filtros = useMemo(() => formatFilters({ filters }), [filters])
  const [filterState, setFilterState] = useState(filtros)
  const [optionsDisplayed, setOptionsDisplayed] = useState(filtros)

  const options = useMemo(() => {
    const filter = filtrarArray(copyNewArray, filterState)
    return formatFilters({ filters: filter })
  }, [optionsDisplayed, filterState])


  const onChangeMultiselect = (value, key) => {
    setFilterState({ ...filterState, [key]: value })
    setChange({ ...initialChangeTrue, [key]: false })
    const current = filtrarArray(copyNewArray, filterState)
    const formated = formatFilters({ filters: current })
    setOptionsDisplayed({ ...formated, [key]: optionsDisplayed[key] })
  }

  const onClearFilters = () => {
    setFilterState(filtros)
    setOptionsDisplayed(filtros)
    setChange(initialChangeTrue)
  }

  return (
    <Card>
      <DialogMaterials
        open={openDialogMaterial}
        onClose={handleDialogMaterial}
        materialsInfo={materialsInfo}
      />
      <CardBody className={classes.containerCard}>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            onSubmitForm({ ...form, ...options })
          }}
        >
          <FormLabel component="legend">
            {' '}
            <b>Global Auteco Planing System</b>
          </FormLabel>
          <Grid
            container
            className={classes.selectorsContainer}
            spacing={2}
            style={{ maxWidth: '1600px' }}
          >
            {filters.length > 0 ? (
              <>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.vertical}
                    values={options.vertical}
                    change={change.vertical}
                    label="Vertical"
                    onChange={(value) => onChangeMultiselect(value, 'vertical')}
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.clasificacion}
                    values={options.clasificacion}
                    label="Clasificación"
                    change={change.clasificacion}
                    onChange={(value) =>
                      onChangeMultiselect(value, 'clasificacion')
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.categoria}
                    values={options.categoria}
                    change={change.categoria}
                    label="Categoria"
                    onChange={(value) =>
                      onChangeMultiselect(value, 'categoria')
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.subcategoria}
                    values={options.subcategoria}
                    change={change.subcategoria}
                    label="Sub Categoria"
                    onChange={(value) =>
                      onChangeMultiselect(value, 'subcategoria')
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.segmento}
                    values={options.segmento}
                    change={change.segmento}
                    label="Segmento"
                    onChange={(value) =>
                      onChangeMultiselect(value, 'segmento')
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.sub_segmento}
                    values={options.sub_segmento}
                    change={change.sub_segmento}
                    label="Sub Segmento"
                    onChange={(value) =>
                      onChangeMultiselect(value, 'sub_segmento')
                    }
                  />
                </Grid>

                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.marca}
                    values={options.marca}
                    change={change.marca}
                    label="Marca"
                    onChange={(value) => onChangeMultiselect(value, 'marca')}
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.familia}
                    values={options.familia}
                    change={change.familia}
                    label="Familia"
                    onChange={(value) =>
                      onChangeMultiselect(value, 'familia')
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.acreedor}
                    values={options.acreedor}
                    change={change.acreedor}
                    label="Acreedor"
                    onChange={(value) => onChangeMultiselect(value, 'acreedor')}
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.grupo_compras}
                    values={options.grupo_compras}
                    change={change.grupo_compras}
                    label="Grupo de compras"
                    onChange={(value) =>
                      onChangeMultiselect(value, 'grupo_compras')
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.indicador_abc}
                    values={options.indicador_abc}
                    label="Indicador ABC"
                    onChange={(value) =>
                      onChangeMultiselect(value, 'indicador_abc')
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <MultiSelect
                    options={optionsDisplayed.estado}
                    values={options.estado}
                    change={change.estado}
                    label="Estado"
                    onChange={(value) => onChangeMultiselect(value, 'estado')}
                  />
                </Grid>
                <Button
                  color="warning"
                  className={classes.btnClear}
                  onClick={onClearFilters}
                >
                  Restablecer filtros
                </Button>
              </>
            ) : null}
          </Grid>
          <section className={classes.sectionRadioGroup}>
            <FormLabel component="legend">
              <b>Tipos de simulaciones de venta</b>
            </FormLabel>
            <Divider className={classes.divider} />
            <Grid style={{ marginLeft: '5px' }} container spacing={2}>
              <Grid item xs={6}>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="gender"
                    name="Selector"
                    value={form.type || ''}
                    input={<BootstrapInput />}
                    onChange={(event) =>
                      setForm({ ...form, type: event.target.value })
                    }
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Proyección de Venta"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label="Histórico de Demanda"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} sm={4}>
                <InputLabel className={classes.labelDate}>
                  Fecha inicial
                </InputLabel>
                <Input
                  type="month"
                  onChange={(event) => {
                    setForm((prev) => ({
                      ...prev,
                      fechas: [`${event.target.value}-01`, prev.fechas[1]],
                    }))
                  }}
                  fullWidth
                />
                <InputLabel className={classes.labelDate}>
                  Fecha final
                </InputLabel>
                <Input
                  type="month"
                  onChange={(event) => {
                    setForm((prev) => ({
                      ...prev,
                      fechas: [prev.fechas[0], `${event.target.value}-01`],
                    }))
                  }}
                  style={{ marginBottom: '6px' }}
                  fullWidth
                />
                <Box className={classes.containerMaterialsBtn}>
                  <TextField
                    onChange={(e) => {
                      const { value } = e.target
                      const array = value !== '' ? value.split(' ') : []
                      setForm({ ...form, material: array })
                    }}
                    label="Material"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                  />
                  <Button
                    type="button"
                    className={classes.btnInfoMaterials}
                    style={{
                      backgroundColor: disabledBtnMaterial ? 'gray' : 'black',
                    }}
                    disabled={disabledBtnMaterial}
                    onClick={() => handleDialogMaterial(true, true)}
                  >
                    ?
                  </Button>
                </Box>
                <FormHelperText>
                  Escriba los materiales separados por un espacio
                </FormHelperText>
                <Button type="onSubmit " color="warning" fullWidth>
                  Ejecutar
                </Button>
              </Grid>
            </Grid>
          </section>
        </form>
      </CardBody>
    </Card>
  )
}

export default SPform
